<div class="treemap__page-wrapper">
  <div class="loading" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <div class="treemap__chart" *ngIf="!loading">
    <app-card [name]="treemapChartTitle" [showIcon]="false">
      <app-treemap-chart [citationCounts]="citationCounts"></app-treemap-chart>
    </app-card>
  </div>
</div>
